import { render, staticRenderFns } from "./FormAgregarDiaFestivo.vue?vue&type=template&id=2082d977&scoped=true"
import script from "./FormAgregarDiaFestivo.vue?vue&type=script&lang=js"
export * from "./FormAgregarDiaFestivo.vue?vue&type=script&lang=js"
import style0 from "./FormAgregarDiaFestivo.vue?vue&type=style&index=0&id=2082d977&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082d977",
  null
  
)

export default component.exports